// extracted by mini-css-extract-plugin
export default {"btnContainer":"buttonsFooter_btnContainer__SxUjp","btnRigth":"buttonsFooter_btnRigth__pr11G","btnLeft":"buttonsFooter_btnLeft__it7Kw"};